const FieldLabel = ({ children, required }) => (
  <label className="field-label">
    {children}
    {required && <span className="required"> *</span>}
  </label>
);

export default FieldLabel;
